import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';
import chevronSvg from '../../../assets/angle-down-900.svg';
import './carouselEdges.scss';
var ScrollState = /*#__PURE__*/function (ScrollState) {
  ScrollState[ScrollState["left"] = -1] = "left";
  // all the way left
  ScrollState[ScrollState["mid"] = 0] = "mid";
  // somewhere in the middle
  ScrollState[ScrollState["right"] = 1] = "right"; // all the way right
  return ScrollState;
}(ScrollState || {});
var CarouselButton = function CarouselButton(_ref) {
  var left = _ref.left,
    onClick = _ref.onClick,
    active = _ref.active;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('carousel-button', {
      left: left,
      active: active
    }),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("img", {
    src: chevronSvg,
    alt: left ? 'Scroll left' : 'Scroll right'
  }));
};
var ScrollEdge = function ScrollEdge(_ref2) {
  var _ref2$left = _ref2.left,
    left = _ref2$left === void 0 ? false : _ref2$left,
    active = _ref2.active,
    onScroll = _ref2.onScroll;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('carousel-edge', {
      'carousel-edge-left': left,
      'carousel-edge-right': !left,
      active: active
    })
  }, /*#__PURE__*/React.createElement(CarouselButton, {
    active: active,
    onClick: function onClick() {
      return onScroll(left ? -1 : 1);
    },
    left: left
  }));
};

// how many pixels to scroll before showing/hiding the edge buttons
var BUTTON_DISPLAY_MARGIN = 15;
export var CarouselEdges = function CarouselEdges() {
  var ref = useRef(); // the .CarouselEdges container, just used for starting the traversal
  var scrollRef = useRef(); // actual scrolling element

  var _useState = useState(ScrollState.left),
    _useState2 = _slicedToArray(_useState, 2),
    scrollState = _useState2[0],
    setScrollState = _useState2[1];
  useEffect(function () {
    // do a little traversal to get the scrolling container
    var island = ref.current.parentElement;
    var container = island.parentElement;
    var scroll = container.querySelector('.carousel');
    scrollRef.current = scroll;

    // set up a listener to update the display when the user scrolls
    var abort = new AbortController();
    scroll.addEventListener('scroll', function (e) {
      var _ref3 = e.target,
        scrollLeft = _ref3.scrollLeft,
        scrollWidth = _ref3.scrollWidth,
        clientWidth = _ref3.clientWidth;
      var scrollRight = scrollWidth - (scrollLeft + clientWidth);
      setScrollState(function (s) {
        if (scrollLeft < BUTTON_DISPLAY_MARGIN) return ScrollState.left;
        if (scrollRight < BUTTON_DISPLAY_MARGIN) return ScrollState.right;
        return ScrollState.mid;
      });
    }, {
      signal: abort.signal
    });
    return function () {
      return abort.abort();
    };
  }, []);
  var scroll = useCallback(function (dir) {
    var _scrollRef$current;
    var itemWidth = scrollRef.current.querySelector('.carousel-item').clientWidth;
    // usually scroll about 30% of the view, but always at least a whole item
    var delta = dir * Math.max(itemWidth, scrollRef.current.clientWidth * 0.3);
    var pos = scrollRef.current.scrollLeft + delta;
    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.scrollTo({
      left: pos,
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "CarouselEdges",
    ref: ref
  }, /*#__PURE__*/React.createElement(ScrollEdge, {
    left: true,
    active: scrollState !== ScrollState.left,
    onScroll: scroll
  }), /*#__PURE__*/React.createElement(ScrollEdge, {
    active: scrollState !== ScrollState.right,
    onScroll: scroll
  }));
};